module.exports = require('./helpers/bundle-url').getBundleURL('kBjr5') + "BNBLogo.3dada3dc.svg";